import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  screen,
  spacing
} from '../../../theme';
import { Heading2 } from '../../shared/Typography';

export const StyledSection = styled.div`
  background-color: ${color('white')};
  padding-top: ${spacing('xl4')};
  padding-bottom: ${spacing('xl4')};
`;

export const StyledContainer = styled.div`
  background-color: ${color('white')};
  max-width: ${container('lg')};
  margin: auto;
  display: flex;
  align-items: center;
  gap: ${spacing('xl')};
  font-size: ${fontSize('lg')};
  line-height: 1.6;
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};

  @media (max-width: ${screen('mdMax')}) {
    flex-direction: column;
    font-size: ${fontSize('md')};
    line-height: 1.5;
  }

  ${Heading2} {
    margin-bottom: ${spacing('lg')};

    &::before {
      left: 0;
      transform: unset;
    }
  }

  p {
    margin: 0;
  }

  a {
    font-weight: ${fontWeight('extraBold')};
  }

  img {
    max-width: 25.5rem;
    display: block;
  }
`;
